.classic2773711173__root {
    -st-states: darkMode;
}

/* st-namespace-reference="../../../src/skins/classic.st.css" */